<template>
    <div class="resiliency-badges">
        <div v-for="yearBadges in badgesByYear" class="resiliency-badges__year">
            <h4>{{yearBadges.year}}</h4>
            <div v-for="badge in yearBadges.badge_data" class="resiliency-badges__item">
                <img v-if="badge.src" v-tooltip="badge.name" :src="badge.src" :alt="badge.name" class="resiliency-badges__item__logo">
                <ul class="resiliency-badges__item__products list-style-none">
                    <li v-for="product in splitProducts(badge.products)" :key="product">{{ product }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
    // import { ref } from 'vue'

    const props = defineProps({
        badgesByYear: { type: Array }
    })

    function splitProducts(products) {
        return products.split('\n').filter(product => product.trim() !== '');
    }

</script>